<template lang="pug">
  ods-module.consultDetail
    .consul__header
        .flex-container.align-center.consultDetail__back
            ods-button(
                @click="handleClick"
                type="text"
                icon="ods-icon-arrow-left")
            p.tp-m-deci.ods-breadcrumb__separator {{ this.$t('commerceInfo.receipts') }}
    ods-table(
      v-loading="loadingTable"
      style='width: 100%'
      :data='tableDataRendered'
      :default-sort = "{prop: 'fremesa', order: 'descending'}"
      )
      ods-table-column(prop='fecemimov' label='Fecha del recibo' sortable)
        template(slot-scope="scope")
          div {{ scope.row.fecemimov | formatDateLocale }}
      ods-table-column(prop='cuenta' label='Cuenta asociada' sortable)
        template(slot-scope="scope")
          span {{ scope.row.iban | formatAccount(scope.row.ctacargo) }}
      ods-table-column(prop='imprec' label='Importe recibo' sortable)
        template(slot-scope="scope")
          div {{ scope.row.imprec | toCurrencyCode(scope.row.clamon) }}
      ods-table-column(prop='descodproced' label='Tipo' sortable)
      ods-table-column(prop='dessituarec' label='SITUACIÓN' sortable class-name="cell-tag")
        template(slot-scope="scope")
          ods-tag(:type="getType(scope.row.situarec)") {{ scope.row.dessituarec }}

    div.footer
      paginator(
        :isNextPage="indMasDatos"
        :currentPage="currentPage"
        @buttonPrevAction="getPrevPage"
        @buttonNextAction="getNextPage")
    //- ods-pagination(
    //-   :page-sizes='[5, 10, 50, 100]',
    //-   :page-size="itemsPerPage",
    //-   layout='prev, pager, next',
    //-   :total='totalData'
    //-   @size-change='handleSizeChange',
    //-   @current-change='handleCurrentChange'
    //-   style="text-align: right; margin-top: 20px")

</template>

<script>
import { mapGetters } from 'vuex'
import Paginator from '@/components/shared/Paginator'

export default {
  name: 'RecibosTable',

  components: {
    Paginator
  },

  data () {
    return {
      defaultParams: {
        codproceso: this.$route.params.codproceso,
        codcom: this.$route.params.comercio ? this.$route.params.comercio.codcom : '',
        numrefrem: this.$route.params.numrefrem,
        clamon: this.$route.params.clamon
      },
      paginationParams: null,
      tableData: null,
      tableDataRendered: null,
      currentPage: null,
      indMasDatos: null,
      loadingTable: false
    }
  },

  computed: {
    ...mapGetters([
      // 'itemsPerPage'
    ])
  },

  methods: {
    handleClick () {
      this.$router.push({
        name: 'Commerce',
        path: `/commerce/${this.$route.params.comercio.registro_Numero}`,
        params: {
          id: this.$route.params.comercio.registro_Numero,
          comercio: this.$route.params.comercio
        }
      })
    },

    async getData (params) {
      this.loadingTable = true
      // Listado de Consultas - Ver recibos
      await this.$store.dispatch('listReceipts', params)
        .then((res) => {
          this.loadingTable = false
          if (res.registros) {
            this.tableData = Array.isArray(res.registros) ? res.registros : [res.registros]
            this.tableDataRendered = this.tableData
          } else {
            this.tableData = null
            this.tableDataRendered = this.tableData
          }
          this.currentPage = res.pantPagina
          this.indMasDatos = res.indMasDatos
          this.paginationParams = {
            claveInicio: res.claveInicio,
            claveFin: res.claveFin
          }
          // this.totalData = res.length
          // this.handlePagination()
        })
    },

    getInitialData () {
      const params = {
        ...this.defaultParams
      }
      this.getData(params)
    },

    getPrevPage () {
      const params = {
        ...this.defaultParams,
        ...this.paginationParams,
        retroceder: true
      }
      this.getData(params)
    },

    getNextPage () {
      const params = {
        ...this.defaultParams,
        ...this.paginationParams,
        avanzar: true
      }
      this.getData(params)
    },

    // handleSizeChange (val) {
    //   this.itemsPerPage = val
    //   this.handlePagination()
    // },

    // handleCurrentChange (val) {
    //   this.currentPageData = val
    //   this.handlePagination()
    // },

    // handleSelectionChange (val) {
    //   this.$emit('rowSelectedCount', val.length)
    // },

    // handlePagination (arr) {
    //   if (Array.isArray(this.data)) {
    //     this.tableData = this.data.slice(
    //       (this.currentPageData - 1) * this.itemsPerPage,
    //       this.currentPageData * this.itemsPerPage)
    //   }
    // },

    getType (row) {
      switch (row) {
        case 2:
        case 6:
        case 10:
          return 'success'
        case 1:
        case 8:
          return 'warning'
        default:
          return 'danger'
      }
    }
  },

  beforeMount () {
    // this.getInitialData()
  },

  mounted () {
    if (this.$route.params.numrefrem) {
      this.getInitialData()
      // this.handlePagination()
      this.$route.params.commerce = sessionStorage.getItem('descComercio')
      this.$route.params.chain = sessionStorage.getItem('descCadena')
    } else {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.notfound {
  margin-top: rem(28)
}

/deep/ .ods-table__row {
  cursor: pointer;
}
.consultDetail{
    &__back{
        margin-bottom: 30px;
    }
    &__search{
        margin-bottom: 30px;
    }
    padding: 30px;
    // background: #fff;
    margin: 40px;
    .ods-button--text{
        padding: 0;
    }
}
</style>
